module.exports = __webpack_public_path__ + "media/jingle_title.9bb5815a.mp3";